import script from "./FiltersListContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./FiltersListContainer.vue?vue&type=script&setup=true&lang=ts"

import "./FiltersListContainer.vue?vue&type=style&index=0&id=f2ec71d4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2ec71d4"]])

export default __exports__